/**
 * Compile-time exhaustiveness check; callers should also return a runtime
 * fallback. `tsconfig.json` has `strict: false`, so a `switch` over a union
 * with a missing case is otherwise not a compile error — it silently returns
 * `undefined`.
 */
export function assertNever(value: never): void {
  void value;
}
